//#region Old Code

import React from 'react';
import request from 'arcdynamic-request';
import {FIRMS} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
// import { GET_FIRMS } from '../Graphql/Queries/FirmQuery';
import { ApolloConsumer } from '@apollo/client';
import { GetOldResponse } from '../ResponseConversion/GetOldResponse';
import { GET_ALL_COMPANIES_FIRM_QUERY, GET_COMPANY_FIRM_QUERY } from '../Graphql/CompanyQueries/allCompanyQuery';
import { fetchData } from '../Service/graphQlService';

const findIndex = require('lodash.findindex');
const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectFirm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            hasChildValue: false
        };
    }

    componentDidMount() {
        this.fetch(0);
    }

    fetch(offset) {
        const options = {
            limit: {
                count: limit,
                offset: offset * limit,
            },
            column: ['NAME', 'ARCIMEDES_ROW_ID', 'PARENT_FIRM'],
            filter: [
            // TODO: Temp fix for STRIVE not being visible
                // {
                //     code: 'NAME',
                //     text: '',
                //     type: 'notNull',
                // },
                {
                    code: 'DELETED',
                    text: '',
                    type: 'null',
                },
            ],
            filterType: 'and',
        };

        if (this.props.excludeChildren) {
            options.filter.push({
                code: 'PARENT_FIRM',
                text: '',
                type: 'null',
            })
        }

        // request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.getData',
        //     params: ['code', FIRMS, options],

        fetchData(GET_COMPANY_FIRM_QUERY, {type:"Firm"})

        // const token = localStorage.getItem('authToken');
        //         this.client.query({
        //             // query: GET_FIRMS, variables: {},fetchPolicy: "no-cache",
        //             query: GET_ALL_COMPANIES_FIRM_QUERY, variables: {},fetchPolicy: "no-cache",
        //             context: {
        //                 headers: {
        //                     authorization: `Bearer ${token}`, // Bearer token added here
        //                 },
        //             }
        // })
        .then(res => {
            // Convert each level into an array
            const transformedRes = [{
                data: {
                    getFirms: [{
                        //here directly accesing firms array for data matching in GetOldResponse purpose
                        // ...res.data.getFirms.firms
                        ...res.data.getCompanies.data
                        //firms: [...res.data.getFirms.firms]
                    }]
                }
            }];
            const result = GetOldResponse(transformedRes[0],true).responses;
            const transformedresult = result[0].data.map((item) => Object.values(item));
            this.setState(prevState => {
                //const items = prevState.items.concat(res.data);
                const items = prevState.items.concat(transformedresult[0]);
                return {
                    items,
                };
            });
            if (res.data.length >= limit) {
                this.fetch(++offset);
            } else {
                const items = [];
                const index = this.handleParentAndChildFirms(cloneDeep(this.state.items));
                Object.keys(index).forEach(id => {
                    items.push(index[id].parent);
                    index[id].children.forEach(x => {
                        x.NAME = '\u00a0\u00a0– '+x.NAME;
                        items.push(x);
                    });
                });
                this.setState({items});
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newFirm !== nextProps.newFirm) {
            let items = cloneDeep(this.state.items);
            const newFirm = {...nextProps.newFirm}
            if (newFirm.parent_firm) {
                const parentFirmIndex = findIndex(items, {"ARCIMEDES_ROW_ID": newFirm.parent_firm});
                newFirm.name = '\u00a0\u00a0– ' + newFirm.name;
                items.splice(parentFirmIndex + 1, 0, newFirm);
            } else {
                items.push(newFirm);
            }

            this.setState({items});
        }
    }

    handleParentAndChildFirms(res) {
        const index = {};

        res.filter(x => !x.PARENT_FIRM)
            .sort((a,b)=> {
                if (a.NAME === 'STRIVE') {
                    return -1;
                } else if (b.NAME === 'STRIVE') {
                    return 1;
                }
                return (a.NAME < b.NAME) ? -1 : 1;
            })
            .forEach(x => {
                index['x'+x.ARCIMEDES_ROW_ID] = {
                    parent: x,
                    children: [],
                };
            });

        res.filter(x => x.PARENT_FIRM).forEach(x => {
            if (index['x'+x.PARENT_FIRM] && index['x'+x.PARENT_FIRM].children) {
                index['x'+x.PARENT_FIRM].children.push(x);
            }
        });

        return index;
    }

    render() {
        const { items } = this.state;
        sessionStorage.setItem("companyData", JSON.stringify(items));
        const { 
            theme, 
            value, 
            valueKey,
            firmName,
            label, 
            disabled, 
            data, 
            isFilter, 
            withAddNew, 
            hasDrawer, 
            handleParentChange, 
            addNewItem,
            deleted,
            viewMode,
            ...rest
        } = this.props;

        return (
            <ApolloConsumer>
                             {client => {
                                 if (!this.client) {
                                    this.client = client;
                                }
                                return (
            <Dropdown theme={theme}
                      optionsType='firm'
                      optionKey='ARCIMEDES_ROW_ID'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      firmName={firmName}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      withAddNew={withAddNew}
                      hasDrawer={hasDrawer}
                      handleParentChange={handleParentChange}
                      addNewItem={addNewItem}
                      deleted={deleted}
                      viewMode={viewMode}
                      {...rest}
            />
        )
                         }}
                    </ApolloConsumer>

        )
    }
}

SelectFirm.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    firmName:PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    hasDrawer: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectFirm;

//#endregion

//#region new code
// import React from 'react';
// import request from 'arcdynamic-request';
// import { FIRMS } from '../../consts/tables';
// import Dropdown from "../Dropdown/Dropdown";
// import PropTypes from "prop-types";
// import { ApolloConsumer } from '@apollo/client';
// import { GET_FIRMS } from '../Graphql/Queries/FirmQuery';

// const findIndex = require('lodash.findindex');
// const cloneDeep = require('lodash.clonedeep');
// const limit = 1000;

// class SelectFirm extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             items: [],
//             hasChildValue: false
//         };
//         this.client = null;
//     }

//     componentDidMount() {
//         if (this.client) {
//             this.fetch(0);
//         }

//     }

//     fetch(offset) {
//         const options = {
//             limit: {
//                 count: limit,
//                 offset: offset * limit,
//             },
//             column: ['NAME', 'ARCIMEDES_ROW_ID', 'PARENT_FIRM'],
//             filter: [
//                 // TODO: Temp fix for STRIVE not being visible
//                 // {
//                 //     code: 'NAME',
//                 //     text: '',
//                 //     type: 'notNull',
//                 // },
//                 {
//                     code: 'DELETED',
//                     text: '',
//                     type: 'null',
//                 },
//             ],
//             filterType: 'and',
//         };

//         if (this.props.excludeChildren) {
//             options.filter.push({
//                 code: 'PARENT_FIRM',
//                 text: '',
//                 type: 'null',
//             })
//         }
//         var pageParams = {
//             page: offset * limit,
//             pageSize: limit
//         }
//         // request(arc.path.api, {
//         //     service: 'arcimedes',
//         //     action: 'open.datasource.table.Data.getData',
//         //     params: ['code', FIRMS, options],
//         // })
//         const token = localStorage.getItem('authToken');
//         this.client.query({
//             query: GET_FIRMS, variables: {},fetchPolicy: "no-cache",
//             context: {
//                 headers: {
//                     authorization: `Bearer ${token}`, // Bearer token added here
//                 },
//             }
//         })
//             .then(res => {
//                 this.setState(prevState => {
//                     const items = prevState.items.concat(res.data.getFirms);
//                     return {
//                         items,
//                     };
//                 });
//                 if (res.data.length >= limit) {
//                     this.fetch(++offset);
//                 } else {
//                     const items = [];
//                     const index = this.handleParentAndChildFirms(cloneDeep(this.state.items));
//                     Object.keys(index).forEach(id => {
//                         items.push(index[id].parent);
//                         index[id].children.forEach(x => {
//                             x.NAME = '\u00a0\u00a0– ' + x.NAME;
//                             items.push(x);
//                         });
//                     });
//                     this.setState({ items });
//                 }
//             });
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.newFirm !== nextProps.newFirm) {
//             let items = cloneDeep(this.state.items);
//             const newFirm = { ...nextProps.newFirm };

//             if (newFirm.PARENT_FIRM) {
//                 const parentFirmIndex = findIndex(items, { "ARCIMEDES_ROW_ID": newFirm.PARENT_FIRM });
//                 newFirm.NAME = '\u00a0\u00a0– ' + newFirm.NAME;
//                 items.splice(parentFirmIndex + 1, 0, newFirm);
//             } else {
//                 items.push(newFirm);
//             }

//             this.setState({ items });
//         }
//     }

//     handleParentAndChildFirms(res) {
//         const index = {};

//         res.filter(x => !x.PARENT_FIRM)
//             .sort((a, b) => {
//                 if (a.NAME === 'STRIVE') {
//                     return -1;
//                 } else if (b.NAME === 'STRIVE') {
//                     return 1;
//                 }
//                 return (a.NAME < b.NAME) ? -1 : 1;
//             })
//             .forEach(x => {
//                 index['x' + x.ARCIMEDES_ROW_ID] = {
//                     parent: x,
//                     children: [],
//                 };
//             });

//         res.filter(x => x.PARENT_FIRM).forEach(x => {
//             if (index['x' + x.PARENT_FIRM] && index['x' + x.PARENT_FIRM].children) {
//                 index['x' + x.PARENT_FIRM].children.push(x);
//             }
//         });

//         return index;
//     }

//     render() {
//         const { items } = this.state;
//         const {
//             theme,
//             value,
//             valueKey,
//             firmName,
//             label,
//             disabled,
//             data,
//             isFilter,
//             withAddNew,
//             hasDrawer,
//             handleParentChange,
//             addNewItem,
//             deleted,
//             viewMode,
//             ...rest
//         } = this.props;

//         return (
//             <ApolloConsumer>
//                 {client => {
//                     if (!this.client) {
//                         this.client = client;
//                     }
//                     return (
//                         <Dropdown theme={theme}
//                             optionsType='firm'
//                             optionKey='ARCIMEDES_ROW_ID'
//                             options={items}
//                             value={value}
//                             valueKey={valueKey}
//                             firmName={firmName}
//                             label={label}
//                             disabled={!items || disabled}
//                             data={data}
//                             isFilter={isFilter}
//                             withAddNew={withAddNew}
//                             hasDrawer={hasDrawer}
//                             handleParentChange={handleParentChange}
//                             addNewItem={addNewItem}
//                             deleted={deleted}
//                             viewMode={viewMode}
//                             {...rest}
//                         />
//                     )
//                 }}
//             </ApolloConsumer>

//         )
//     }
// }

// SelectFirm.propTypes = {
//     theme: PropTypes.oneOf(['default', 'white', 'dark']),
//     value: PropTypes.string,
//     valueKey: PropTypes.string.isRequired,
//     firmName: PropTypes.string,
//     label: PropTypes.string,
//     disabled: PropTypes.bool,
//     data: PropTypes.object,
//     withAddNew: PropTypes.bool,
//     handleParentChange: PropTypes.func.isRequired,
//     isFilter: PropTypes.bool,
//     viewMode: PropTypes.bool,
//     hasDrawer: PropTypes.bool,
//     addNewItem: PropTypes.func,
//     deleted: PropTypes.bool,
//     isFromProperty: PropTypes.bool,
// };

//export default SelectFirm;
//#endregion